module.exports = __webpack_public_path__ + "media/images/open_eye-a61d35c34ed122569b6d38e032c0b801.svg";